import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { Vendor } from 'model/index';

import 'swiper/css';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';


import {
    selectVendors,
    filterPrimeVendor
} from 'store/order';
export const VendorSliderComponent: React.FC = () => {
    const dispatch = useAppDispatch();

    const vendors = useAppSelector(selectVendors);

    const vendorsWithLogos = vendors.filter((vendor: Vendor) => {
        return vendor.logo != null && vendor.primeVendor && vendor.logo.length > 0;
    });

    // Duplicate slides if needed for Swiper loop mode (need at least 2x slidesPerView)
    const minSlidesForLoop = 25;
    const slides = React.useMemo(() => {
        if (vendorsWithLogos.length === 0) return [];
        if (vendorsWithLogos.length >= minSlidesForLoop) return vendorsWithLogos.map((v, i) => ({ ...v, _key: `${v.vendorId}-${i}` }));

        const result: (Vendor & { _key: string })[] = [];
        let copyIndex = 0;
        while (result.length < minSlidesForLoop) {
            vendorsWithLogos.forEach((vendor, i) => {
                if (result.length < minSlidesForLoop) {
                    result.push({ ...vendor, _key: `${vendor.vendorId}-${copyIndex}-${i}` });
                }
            });
            copyIndex++;
        }
        return result;
    }, [vendorsWithLogos]);

    const onVendorSelect = (vendor: Vendor) => {
        dispatch(filterPrimeVendor(vendor));
    };

    const params = {
        modules: [Autoplay],
        centeredSlides: true,
        loop: true,
        slidesPerView: 5,
        speed: 600,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            640: {
                slidesPerView: 4,
                spaceBetween: 10
            },
            1024: {
                slidesPerView: 10,
                spaceBetween: 10
            },
            1600: {
                slidesPerView: 16,
                spaceBetween: 10
            }
        }
    };

    if (slides.length > 0) {
        return (
            <div className="vendor-slider">
                <Swiper  {...params}>
                    {slides.map((vendor) => {
                        return <SwiperSlide key={vendor._key}>
                            <div className="slider-img" title={vendor.vendorName} onClick={() => onVendorSelect(vendor)}>
                                <img src={vendor.logo} alt={vendor.vendorName} loading="lazy" />
                            </div>
                        </SwiperSlide>;
                    })}
                </Swiper>
            </div >
        );
    } else {
        return null;
    }
}
export const VendorSlider = React.memo(VendorSliderComponent);
